import logger from '../utils/logger';
import { rumService } from './rum';

interface EncryptLoginHintResponse {
  token: string;
  expiresAt: number;
}

/**
 * Calls the SHIM's EncryptLoginHint endpoint to encrypt an email for use as login_hint.
 * Returns the encrypted token string on success, or null on failure.
 * On failure, login_hint is NOT sent — the user sees Builder ID's normal email entry page.
 */
export async function encryptLoginHint(
  email: string,
  shimUrl: string
): Promise<string | null> {
  const correlationId = crypto.randomUUID();
  try {
    const response = await fetch(`${shimUrl}/oidc/encryptLoginHint`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Correlation-Id': correlationId,
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      logger.debug(
        'EncryptLoginHint API returned non-200, login_hint will not be sent'
      );
      rumService.recordEvent('EncryptLoginHintFailure', {
        reason: `HTTP_${response.status}`,
        correlationId,
      });
      return null;
    }

    const data: EncryptLoginHintResponse = await response.json();
    rumService.recordEvent('EncryptLoginHintSuccess', { correlationId });
    return data.token;
  } catch (error) {
    logger.debug(
      'EncryptLoginHint API call failed, login_hint will not be sent',
      error
    );
    rumService.recordEvent('EncryptLoginHintFailure', {
      reason: 'NetworkError',
      correlationId,
    });
    return null;
  }
}
